import { Circle } from '@react-three/drei';
import { type Size } from '@react-three/fiber';
import React from 'react';
import { DemarcationShapeMaterial } from '@/components/property-selector/draw-components/draw-demarcation';
import { normalizePoint } from '@/components/property-selector/utils';
import { type Point } from '@/types';

type DrawMarkersProps = {
  points: Point[];
  size: Size;
};

export function DrawMarkers({ points, size }: DrawMarkersProps) {
  return points.map((point, index) => {
    const normalizedPoint = normalizePoint(point, size);
    const normalizedSize = normalizePoint({ x: 0.5, y: 0.5 }, size);
    return (
      <Circle
        key={`marker-${index}`}
        args={[0.05]}
        position={[normalizedPoint.x, normalizedPoint.y, 0]}
        scale={[normalizedSize.x, normalizedSize.y, 1]}
      >
        <DemarcationShapeMaterial color={0xffcc00} />
      </Circle>
    );
  });
}
